import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';

import Page from '../../../components/Editor/Page';
import {
	isEditablePage,
	getPageEditableTextFieldsIds,
	getPageEditableMediaIds,
	getPageEditableLinksIds,
	getIsTransparentPage,
} from '../selectors';
import UrlUtils from '../../../utils/url';

const mapStateToProps = (state: StoreState) => {
	const {
		editor: {
			type,
			slider: { page, prevPage },
			pages,
			isThumbnailsDisplayed,
			activeItem,
			pageZoom,
		},
		galleryInfos,
		routerParamsHistory,
	} = state;

	const { params: { resourceId } } = routerParamsHistory[routerParamsHistory.length - 1];
	const { fontsPath, googleFontsPath } = pages[pages[page] ? page : prevPage];

	return {
		editorType: type,
		page,
		width: pages[pages[page] ? page : prevPage].width,
		height: pages[pages[page] ? page : prevPage].height,
		html: pages[page] ? pages[page].html : '',
		zoom: pageZoom,
		isThumbnailsDisplayed,
		isEditable: isEditablePage(state),
		editableTextFieldsIds: getPageEditableTextFieldsIds(state),
		editableMediaIds: getPageEditableMediaIds(state),
		editableLinksIds: getPageEditableLinksIds(state),
		isSomeEditableItemActive: !!activeItem.id,
		iframeUrl: UrlUtils.getComponentUrl(galleryInfos, +resourceId),
		fontsPath,
		googleFontsPath,
		isTransparent: getIsTransparentPage(state),
	};
};

export default connect(mapStateToProps)(Page);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/Page/index.tsx